import Analytics from 'analytics-opencare';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

const analytics = new Analytics();

const createUrl = (url) => {
  try {
    return new URL(url).toString();
  } catch {
    // Do nothing
  }

  const path = url.startsWith('/') ? url : `/${url}`;
  return `${CONFIG.SEARCH_APP_V2_URL}${path}`;
};

export class RedirectionService {
  constructor({ history } = {}) {
    this._history = history;
  }

  redirect({ url, reason, analyticsContent = {} }) {
    const finalUrl = createUrl(url);

    analytics.trackRedirect({
      pageType: analytics.pageTypes.MATCH_RESULTS,
      content: {
        ...analyticsContent,
        'redirect-reason': reason,
        'from-url': window.location.href,
        'to-url': finalUrl.toString(),
      },
    });

    const { host, pathname } = new URL(finalUrl);

    if (this._history && host === CONFIG.SEARCH_APP_V2_URL) {
      this._history.push(pathname);
      return;
    }

    analytics.waitForQueue().then(() => window.location.assign(finalUrl));
  }
}

export const useRedirectionService = () => {
  const history = useHistory();

  const createServiceParams = () => ({
    history,
  });
  const createService = () => new RedirectionService(createServiceParams());

  const [service, setService] = useState(createService());

  // Only update the service when the states change
  // This way we can use the entire service in useEffect watchers
  // To watch for any changes in the offer state
  useEffect(() => {
    setService(createService());
  }, Object.values(createServiceParams()));

  return service;
};
